// extracted by mini-css-extract-plugin
export default {"default":"Breadcrumb_default__-E79m"};